import type React from "react";
import { ButtonsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/ButtonsList";
import { i18nFilter } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { Step } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import type { IStepMetadata } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { getRecentParams } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";

export const MarketingChannelsStep: React.FC<IStepMetadata> = (props) => {
    const i18n = i18nFilter();

    const viewTrafficSources = (): void => {
        const finalParamsMarketingChannels = {
            ...{
                ...proNavigator.getState("digitalsuite_website_marketingchannels").defaultQueryParams,
            },
            ...(getRecentParams() ?? {}),
        };

        props.onStepComplete("growth.homepage.wizard.button.marketingChannels");
        proNavigator.go("digitalsuite_website_marketingchannels", finalParamsMarketingChannels);
    };

    return (
        <Step
            {...props}
            title={i18n("growth.homepage.activationWizard.step.marketing_channels.title")}
            description={i18n("growth.homepage.activationWizard.step.marketing_channels.description")}
            buttonsList={
                <ButtonsList
                    buttons={[
                        {
                            text: i18n("growth.homepage.activationWizard.step.marketing_channels.button"),
                            onClick: viewTrafficSources,
                            type: "primary",
                        },
                    ]}
                />
            }
        />
    );
};
